moduleViewApp.service("FieldMapper", ['$filter', ($filter) ->
  (header, index, subIndex) ->
    baseSetter = (field) ->
      (item, val) ->
        if $filter('presence')(val)
          item[field] = val

    simpleSetter = (object, field) ->
      (item, val) ->
        if $filter('presence')(val)
          item[object] ||= {}
          item[object][field] = val

    booleanSetter = (object, field) ->
      (item, val) ->
        if $filter('presence')(val)
          item[object] ||= {}
          val = val.toLowerCase() if _.isString(val)
          item[object][field] = Boolean(JSON.parse(val))

    repeatableSetter = (object, field) ->
      (item, val) ->
        if $filter('presence')(val)
          item[object] ||= {}
          item[object][index] ||= {}
          item[object][index][field] = val

    tagSetter = (object, field) ->
      (item, val) ->
        item[object][subIndex] ||= {}
        item[object][subIndex]["tags"] ||= {}
        item[object][subIndex]["tags"][field] = val

    distractorSetter = (object, field) ->
      (item, val) ->
        if $filter('presence')(val)
          if object == "anchor"
            item[object]["distractors"] ||= {}
            item[object]["distractors"][index] ||= {}
            item[object]["distractors"][index][field] = val
          else
            item[object][subIndex] ||= {}
            item[object][subIndex]["distractors"] ||= {}
            item[object][subIndex]["distractors"][index] ||= {}
            item[object][subIndex]["distractors"][index][field] = val

    # TODO: full vocab fields are not supported yet

    switch header
      when "item_type"
        baseSetter("template_type")
      when "anchor_text_html"
        simpleSetter("anchor", "text_html")
      when "anchor_image"
        simpleSetter("anchor", "image")
      when "anchor_image_alt"
        simpleSetter("anchor", "image_alt")
      when "anchor_sound"
        simpleSetter("anchor", "sound")
#      when "anchor_language"
#        simpleSetter("anchor", "language")
#      when "anchor_part_of_speech"
#        simpleSetter("anchor", "part_of_speech")
      when "anchor_question_html"
        simpleSetter("anchor", "question")
      when "anchor_transliteration_html"
        simpleSetter("anchor", "transliteration_html")
      when "anchor_distractor_text_html"
        distractorSetter("anchor", "text_html")
      when "anchor_distractor_image"
        distractorSetter("anchor", "image")
      when "anchor_distractor_image_alt"
        distractorSetter("anchor", "image_alt")
      when "association_text_html"
        repeatableSetter("associations", "text_html")
      when "association_image"
        repeatableSetter("associations", "image")
      when "association_image_alt"
        repeatableSetter("associations", "image_alt")
      when "association_sound"
        repeatableSetter("associations", "sound")
#      when "association_language"
#        simpleSetter("association", "language")
#      when "association_part_of_speech"
#        simpleSetter("association", "part_of_speech")
      when "association_question"
        repeatableSetter("associations", "question")

      when "association_label"
        repeatableSetter("associations", "label")

      when "association_distractor_text_html"
        distractorSetter("associations", "text_html")
      when "association_distractor_image"
        distractorSetter("associations", "image")
      when "association_distractor_image_alt"
        distractorSetter("associations", "image_alt")
      when "notes_text_html"
        simpleSetter("notes", "text_html")
      when "notes_image"
        simpleSetter("notes", "image")
      when "notes_image_alt"
        simpleSetter("notes", "image_alt")
      when "notes_sound"
        simpleSetter("notes", "sound")
      when "notes_external_resource_url"
        simpleSetter("notes", "external_resource_url")

      when "sentence_text_html"
        repeatableSetter("sentences", "text_html")
      when "sentence_transliteration_html"
        repeatableSetter("sentences", "transliteration_html")
      when "sentence_translation_html"
        repeatableSetter("sentences", "translation_html")
      when "sentence_image"
        repeatableSetter("sentences", "image")
      when "sentence_image_alt"
        repeatableSetter("sentences", "image_alt")
      when "sentence_sound"
        repeatableSetter("sentences", "sound")

      when "association_direction"
        repeatableSetter("associations", "direction")
      when "anchor_random_distractors"
        booleanSetter("anchor", "allow_random_distractors")
      when "association_random_distractors"
        booleanSetter("association", "allow_random_distractors")
      when "ignored", "anchor_language", "anchor_part_of_speech", "association_language", "association_part_of_speech", "legacy_language_pair_id"
        (item, _) ->
          item
      when "tag"
        tagSetter("associations", index)
      else
        throw new Error("FieldMapper: Unexpected header '" + header + "'")
])
